/*
  CODEX CUSTOMIZATION
  File: custom-pick-six.js
  Scope: product template suffix 'pick-six' only
  Purpose:
  - Replace EB bundle slot labels from "Product N" to "Mini Bottle N".
  - Remove "100ML Sample" from dynamic bundle UI text.
  - Handle app-rendered modal/portal content that can mount outside the block wrapper.
*/

(() => {
  const PRODUCT_SLOT_PATTERN = /\bProduct(?=\s*\d+\b)/g;
  const SAMPLE_SUFFIX_TEST_PATTERN = /100ML Sample/i;
  const SAMPLE_SUFFIX_PATTERN = /\s*100ML Sample\b/gi;
  const QUICK_TEXT_TEST_PATTERN = /Product\s*\d+|100ML Sample/i;
  const REPLACEMENT = 'Mini Bottle';

  function replaceProductSlotLabelInTextNode(node) {
    if (!(node instanceof Text)) {
      return;
    }

    const currentValue = node.nodeValue;

    if (!currentValue) {
      return;
    }

    if (currentValue.indexOf('Product') === -1 && !SAMPLE_SUFFIX_TEST_PATTERN.test(currentValue)) {
      return;
    }

    const nextValue = currentValue
      .replace(PRODUCT_SLOT_PATTERN, REPLACEMENT)
      .replace(SAMPLE_SUFFIX_PATTERN, '');

    if (nextValue !== currentValue) {
      node.nodeValue = nextValue;
    }
  }

  function replaceProductSlotLabelsWithin(root) {
    if (!(root instanceof Element || root instanceof DocumentFragment)) {
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      replaceProductSlotLabelInTextNode(textNode);
      textNode = walker.nextNode();
    }
  }

  function processCandidateNode(node) {
    if (node instanceof Text) {
      replaceProductSlotLabelInTextNode(node);
      return;
    }

    if (!(node instanceof Element || node instanceof DocumentFragment)) {
      return;
    }

    const snapshotText = node.textContent;

    if (!snapshotText || !QUICK_TEXT_TEST_PATTERN.test(snapshotText)) {
      return;
    }

    replaceProductSlotLabelsWithin(node);
  }

  function initializePickSixBundleLabels() {
    if (!document.body) {
      return;
    }

    processCandidateNode(document.body);

    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          processCandidateNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(processCandidateNode);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePickSixBundleLabels, { once: true });
  } else {
    initializePickSixBundleLabels();
  }
})();
